import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container,Form, FormControl, Button, Modal  } from "react-bootstrap";
const MessageList = () => {
  const [MessagePet, setMessagePet] = useState([]);
    const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    pet: '',
    owner: '',
    subject: '',
    text: '',
    sender: 'groommer'
  });
useEffect(() => {
  axios.get(`/message-pet/`)
    .then((res) => {
      const data = res.data;
      if (data.length === 0) {
        alert("No message data received");
        return;
      }

      const item = data; // Get the first message
      setMessagePet(item);
      setFormData((prev) => ({
        ...prev,
        pet: item.pet,
        owner: item.owner,
      }));
      alert(item.owner); // ✅ will now show a value
    })
    .catch((err) => console.error("Failed to fetch Message of Pet data:", err));
}, []);



 


  const [activeMessageId, setActiveMessageId] = useState(null);
  const [responseMessage, setResponseMessage] = useState('');
  
const [item, setItem] = useState({ pet: null, owner: null }); 
// or fetch item somewhere before using it

  const handleShowMsg = (messageItem) => {
    setFormData({
      ...formData,
          pet: item.pet_id,           // Numeric ID
          owner: item.owner_id,
    });
    setActiveMessageId(messageItem.id);
    setShowModal(true);
  };


  // close modal & reset form
  const handleClose = () => {
    setShowModal(false);
    setFormData({ pet: '', owner: '', subject: '', text: '', sender: 'groommer' });
  };

  

 const handleSubmit = async (e) => {
  e.preventDefault();

  const now = new Date();
  const currentDate = now.toISOString().split('T')[0]; // 'YYYY-MM-DD'
  const currentTime = now.toTimeString().split(' ')[0]; // 'HH:MM:SS'

  const payload = {
    subject: formData.subject,
    text: formData.text,
    datee: currentDate,
    time: currentTime,
    pet: item?.pet,     // ✅ Correct: Pet is the pet ID
    owner: item?.owner  // ✅ Correct: Owner is the owner ID
  };

  try {
    alert(payload.time);
    const response = await fetch('/create-message/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Server error:', data);
      alert(`Failed to send message: ${JSON.stringify(data)}`);
      return;
    }

    alert('Message successfully sent!');
    setFormData({ subject: '', sender: 'groommer', text: '' });
  } catch (error) {
    console.error('Request error:', error);
    alert('Network error');
  }
};


  return (
    <section style={{
      padding: '2rem',
      background: '#f9f9f9',
      borderRadius: '12px',
      margin: '2rem auto',
      maxWidth: '900px'
    }}>
      <h2 style={{
        textAlign: 'center',
        marginBottom: '2rem',
        color: '#d51b66',
        fontWeight: 'bold',
        fontSize: '2rem'
      }}>
        📬 Pet Appointment Messages
      </h2>

      <div style={{
        position: 'relative',
        marginLeft: '1rem',
        borderLeft: '4px solid #d51b66',
        paddingLeft: '2rem'
      }}>
        
  
 {MessagePet.map((item, index) => (
     <>
        <div key={index} style={{ position: 'relative', marginBottom: '2rem' }}>
          <div style={{
            content: '',
            position: 'absolute',
            left: '-18px',
            top: '0',
            width: '12px',
            height: '12px',
            backgroundColor: '#d51b66',
            borderRadius: '50%',
            border: '2px solid white'
          }} />

          <div style={{ fontSize: '0.9rem', color: '#888', marginBottom: '0.5rem' }}>
            {item.datee} — {item.time}
          </div>

          <div>
            <h4 style={{ fontSize: '1.2rem', color: '#222', marginBottom: '0.5rem' }}>
              {item.subject}
            </h4>
            <p style={{ fontSize: '1rem', color: '#444', marginBottom: '0.5rem' }}>
              {item.text}
            </p>
            <div style={{ fontSize: '0.95rem', color: '#666', marginBottom: '0.5rem' }}>
              <strong>🐾 Pet:</strong> {item.pet_name || 'Unknown Pet'} <br />
              <strong>👤 Owner:</strong> {item.owner_name || 'Unknown Owner'}
            </div>
            <Button
              className="button w-150"
              variant="primary"
              onClick={() => handleShowMsg(item)}
            >
              Reply Message
            </Button>
          </div>
        </div>
     

      {/* Shared Modal */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        className="custom-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>Reply Message</Modal.Title>
        </Modal.Header>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Subject
          </label>
          <textarea
            value={formData.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            className="textarea"
            rows={2}
            placeholder="Type subject here..."
            style={{
              width: "100%", padding: "10px", borderRadius: "6px",
              border: "1px solid #ccc", fontSize: "1rem", marginBottom: "1rem"
            }}
          />
  <label style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Sender
          </label>
          <input type='text' name='pet' value={item.owner} />
<input type='text' name='owner' value={item.pet} />

          <select
            name="sender"
            className="form-control"
            value={formData.sender}
            onChange={(e) => setFormData({ ...formData, sender: e.target.value })}
            style={{
              width: "100%", padding: "10px", borderRadius: "6px",
              border: "1px solid #ccc", fontSize: "1rem", marginBottom: "1rem"
            }}
          >
            <option value="groommer">Pet Grooming</option>
            <option value="owner">Owner</option>
          </select>

          <label style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Message
          </label>
          <textarea
            name="text"
            className="textarea"
            rows={5}
            value={formData.text}
            onChange={(e) => setFormData({ ...formData, text: e.target.value })}
            placeholder="Type your message here..."
            style={{
              width: "100%", padding: "10px", borderRadius: "6px",
              border: "1px solid #ccc", fontSize: "1rem", marginBottom: "1.5rem"
            }}
          />
          <div style={{ textAlign: 'right' }}>
            <button
              type="submit"
              className="square-button"
              style={{
                backgroundColor: "#4CAF50", color: "white",
                padding: "10px 20px", border: "none",
                borderRadius: "6px", cursor: "pointer", fontSize: "1rem"
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
     </>
 ))}
  



    

        
    
      
    </div> 
      
    </section>

    
 );

};
export default MessageList;
